let baseUrl = "";

if (typeof window !== "undefined") {
  const host = window.location.host;

  if (host === "track.devprestigeride.com") {
    const url = "https://www.apitest.devprestigeride.com";
    baseUrl = url;
  } else if (host === "track.prestigeride.com") {
    const url = "https://www.api.devprestigeride.com";
    baseUrl = url;
  } else {
    // Default fallback, agar koi aur domain ho ya localhost
    const url = "http://localhost:9000";
    baseUrl = url;
  }
} else {
  // Server side ya build time fallback
  baseUrl = "http://localhost:9000";
}

const config = {
  baseUrl,
};

export default config;
